import styled from 'styled-components';
import { StyledCard } from '../../../components/Card.component';
import { StyledParamsBlock } from '../../forms/Report/Params.form';
import { StyledNoResult } from '../../../components/NoResult.component';
import { ChartLegendWrapper } from '../../../components/Chart/ChartLegendContent.component';

export const StyledReportPage = styled.div`
  display: grid;
  grid-template-columns: 320px auto;
  gap: 22px;
  padding: 22px;

  ${StyledCard} {
    height: 100%;
    max-height: calc(100vh - 44px - 61px);
    overflow: hidden;
  }

  ${StyledParamsBlock} {
    height: 100%;
    max-height: calc(100vh - 44px - 96px);
    overflow: hidden;
  }

  ${StyledNoResult} {
    padding: 0;
  }
`;

export const StyledChartView = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;
`;

export const StyledChartContainer = styled.div`
  height: 100%;
  flex: 5 1;
`;

export const StyledChartTypeButtonsContainer = styled.div`
  margin-bottom: 16px;
`;

export const StyledChartLegendContainer = styled.div``;

export const StyledPictureLegendContainer = styled.div`
  padding: 16px;

  ${ChartLegendWrapper} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StyledRightPanelContainer = styled.div`
  margin: 48px 0;
  flex: 2 0 0;
  overflow: auto;
`;

export const StyledRightPanelTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const StyledCommonCountWrapper = styled.div`
  > div {
    text-align: center;
  }
`;
